function generateRandomInt(){
    return Math.floor(Math.random() * 2 ** 32)
}

export default generateRandomInt
